import React, { useEffect, useState } from "react";
import Header from "../layouts/Header";
import Footer from "../layouts/Footer";
import { Button, Card, Col, Row, Table, Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import { getToken, getFullName } from '../services/authorize'
import axiosInstance from "../services/axiosInterceptor";
import Swal from "sweetalert2";
import { useLoading } from '../contexts/LoadingContext';
import { useParams, useLocation } from "react-router-dom";

const UPLOAD_BASE = (process.env.REACT_APP_API || 'http://localhost:3002/api').replace(/\/api\/?$/, '').replace(/\/$/, '');
const StudentAvatar = ({ photo, name }) => {
  const [hovered, setHovered] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const initial = name ? name.trim().charAt(0) : '?';
  const src = photo ? `${UPLOAD_BASE}${photo.startsWith('/') ? photo : `/${photo}`}` : null;

  const circleStyle = { width: 28, height: 28, borderRadius: '50%', flexShrink: 0 };
  return (
    <>
      <span
        style={{ position: 'relative', display: 'inline-block', lineHeight: 0 }}
        onMouseEnter={() => src && setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        onClick={() => src && setShowModal(true)}
      >
        {src
          ? <img src={src} alt="" style={{ ...circleStyle, objectFit: 'cover', cursor: 'pointer' }} />
          : <span style={{ ...circleStyle, backgroundColor: '#adb5bd', color: '#fff', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontSize: 12, fontWeight: 600 }}>{initial}</span>
        }
        {src && hovered && (
          <div style={{ position: 'absolute', left: 34, top: '50%', transform: 'translateY(-50%)', zIndex: 1050, background: '#fff', borderRadius: 8, boxShadow: '0 4px 20px rgba(0,0,0,0.25)', padding: 4 }}>
            <img src={src} alt={name} style={{ width: 120, height: 120, objectFit: 'cover', borderRadius: 6, display: 'block' }} />
          </div>
        )}
      </span>
      {src && (
        <Modal show={showModal} onHide={() => setShowModal(false)} centered size="sm">
          <Modal.Body className="p-3 text-center">
            <img src={src} alt={name} style={{ maxWidth: '100%', maxHeight: '70vh', borderRadius: 8 }} />
            {name && <div className="mt-2 fw-semibold small">{name}</div>}
          </Modal.Body>
        </Modal>
      )}
    </>
  );
};

// การ์ดนักเรียน 1 คน สำหรับมุมมองมือถือ
const StudentCard = ({ data, index }) => {
  const isWithdrawn = data.st_status === '0'
  const isTransferred = !!data.transfer_room_id
  return (
    <div className={`border rounded p-3 ${isWithdrawn ? 'bg-danger-subtle' : isTransferred ? 'bg-warning-subtle' : ''}`}>
      <div className="d-flex align-items-center gap-2">
        <StudentAvatar photo={data.st_photo} name={data.st_name} />
        <div className="flex-grow-1" style={{ minWidth: 0 }}>
          <div className="fw-semibold text-truncate">{data.st_name}</div>
          <div className="fs-xs text-muted">#{index + 1} · {data.st_idnumber}</div>
        </div>
      </div>
      <div className="mt-2 pt-2 border-top fs-sm">
        <span className={isWithdrawn ? 'text-danger' : isTransferred ? 'text-warning' : 'text-success'}>
          {isTransferred && !isWithdrawn
            ? `ย้ายไป ม.${data.transfer_class_id}/${data.transfer_room_no}`
            : data.status_text}
        </span>
      </div>
    </div>
  )
}

export default function StudentInClass() {
  const { r_id, c_class, r_no } = useParams(); // get the room_id, class, room number from the URL
  const location = useLocation();
  const { subId = '', subName = '' } = location.state || {}; // รหัสวิชา/ชื่อวิชา ส่งมาจากหน้ารายวิชาที่สอน

  const { setLoading } = useLoading();
  ///// Skin Switch /////
  const currentSkin = (localStorage.getItem('skin-mode')) ? 'dark' : '';
  const [skin, setSkin] = useState(currentSkin);

  const switchSkin = (skin) => {
    if (skin === 'dark') {
      const btnWhite = document.getElementsByClassName('btn-white');
      for (const btn of btnWhite) {
        btn.classList.add('btn-outline-primary');
        btn.classList.remove('btn-white');
      }
    } else {
      const btnOutlinePrimary = document.getElementsByClassName('btn-outline-primary');

      for (const btn of btnOutlinePrimary) {
        btn.classList.remove('btn-outline-primary');
        btn.classList.add('btn-white');
      }
    }

    // Toggle dark mode for all tables
    const tables = document.getElementsByTagName('table');
    for (const table of tables) {
      const theads = table.querySelectorAll('thead'); // หาทุก thead ภายใน table
      if (skin === 'dark') {
        for (const thead of theads) {
          thead.classList.remove('table-secondary');
          thead.classList.add('table-primary');
        }
        table.classList.add('table-dark');
      } else {
        table.classList.remove('table-dark');
        for (const thead of theads) {
          thead.classList.remove('table-primary');
          thead.classList.add('table-secondary');
        }
      }
    }
  }

  switchSkin(skin);

  useEffect(() => {
    switchSkin(skin);
  }, [skin]);

  const [data, setData] = useState({})
  const [yearDisplay, setYearDisplay] = useState("");
  const [view, setView] = useState(() =>
    (typeof window !== 'undefined' && window.innerWidth < 768) ? 'card' : 'table')

  useEffect(() => {
    const yearId = localStorage.getItem('yearId');
    if (!yearId) return;
    axiosInstance.get(`${process.env.REACT_APP_API}/getStudyYear`, {
      headers: { authorization: `Bearer ${getToken()}` }
    })
    .then(res => {
      const found = res.data.find(y => String(y.year_id) === String(yearId));
      if (found) setYearDisplay(String(found.year_year));
    })
    .catch(() => {});
  }, []);

  useEffect(() => {
    setLoading(true);
        
    axiosInstance.get(`${process.env.REACT_APP_API}/listStudentsInClass/${r_id}`, 
    {
      headers: {
          authorization: `Bearer ${getToken()}`
      }
    })
      .then(response => {
        setData(response.data)
        // setIsLoading(false)
        // console.log(response.data)
      })
      .catch(err => {
        console.log(err.response.data.message)
        Swal.fire({
          title: err.response.data.title || err.response.statusText,
          text: err.response.data.message || err.message,
          icon: "error"
        })
      }).finally(() => {
        setLoading(false);
      })

  }, [setLoading, r_id]);

  const escHtml = (str) => String(str ?? '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')

  const handlePrintScoreSheet = () => {
    const students = Array.isArray(data) ? data : []
    const scoreCols = 20 // ช่องว่างสำหรับครูผู้สอนบันทึกคะแนนแต่ละครั้ง
    // คอลัมน์รวมต้องเท่ากับ 100% เพื่อให้พอดีกับความกว้างกระดาษ A4
    const infoPct = 5 + 12 + 26 // เลขที่ + เลขประจำตัว + ชื่อ-สกุล
    const scorePct = (100 - infoPct) / scoreCols

    const colgroup = `<colgroup>
        <col style="width:5%;" />
        <col style="width:12%;" />
        <col style="width:26%;" />
        ${Array.from({ length: scoreCols }).map(() => `<col style="width:${scorePct}%;" />`).join('')}
      </colgroup>`

    const scoreHeadCells = Array.from({ length: scoreCols }).map(() => `<th></th>`).join('')
    const scoreBodyCells = Array.from({ length: scoreCols }).map(() => `<td></td>`).join('')

    const bodyRows = students.length > 0
      ? students.map((s, i) => {
          const isWithdrawn = s.st_status === '0'
          const isTransferred = !!s.transfer_room_id
          const rowClass = isWithdrawn ? ' class="hl-withdrawn"' : (isTransferred ? ' class="hl-transferred"' : '')
          let note = ''
          if (isWithdrawn) note = ' (จำหน่ายแล้ว)'
          else if (isTransferred) note = ` (ย้ายไป ม.${escHtml(s.transfer_class_id)}/${escHtml(s.transfer_room_no)})`
          return `<tr${rowClass}>
          <td class="c">${i + 1}</td>
          <td class="c">${escHtml(s.st_idnumber)}</td>
          <td class="name">${escHtml(s.st_name)}${note ? `<span class="note">${note}</span>` : ''}</td>
          ${scoreBodyCells}
        </tr>`
        }).join('')
      : `<tr><td colspan="${3 + scoreCols}" class="c">ไม่พบข้อมูล</td></tr>`

    const html = `<!DOCTYPE html><html><head><meta charset="UTF-8"><title>ใบบันทึกคะแนน ม.${escHtml(c_class)}/${escHtml(r_no)}</title>
      <style>
        @page { size: A4 portrait; margin: 8mm; }
        * { box-sizing: border-box; }
        html, body { margin: 0; padding: 0; }
        body { font-family: 'Cordia New', 'TH Sarabun New', Tahoma, Arial, sans-serif; font-size: 16px; color: #000; -webkit-print-color-adjust: exact; print-color-adjust: exact; }
        h3 { text-align: center; margin: 0 0 6px 0; font-size: 16px; }
        table { border-collapse: collapse; width: 100%; table-layout: fixed; }
        th, td { border: 1px solid #000; padding: 2px 3px; overflow: hidden; word-wrap: break-word; }
        .head-table { margin-bottom: 6px; }
        .head-table td { vertical-align: middle; }
        .head-table .label { background: #f0f0f0; white-space: nowrap; font-weight: 600; }
        thead th { text-align: center; vertical-align: middle; background: #f0f0f0; }
        tbody .c { text-align: center; }
        tbody .name { padding-left: 6px; }
        tbody tr { height: 22px; }
        tbody .note { font-size: 11px; color: #555; }
        tbody .hl-withdrawn { background: #f8d7da; }
        tbody .hl-transferred { background: #fff3cd; }
        .legend { margin: 4px 0 0 0; font-size: 12px; }
        .legend .box { display: inline-block; width: 12px; height: 12px; border: 1px solid #000; vertical-align: middle; margin: 0 4px 0 10px; }
        .legend .box.w { background: #f8d7da; }
        .legend .box.t { background: #fff3cd; }
      </style></head>
      <body onload="window.print()">
        <h3>โรงเรียนวัฒนธรรมอิสลาม</h3>
        <table class="head-table">
          <colgroup>
            <col style="width:14%;" /><col style="width:36%;" /><col style="width:16%;" /><col style="width:34%;" />
          </colgroup>
          <tr>
            <td class="label">ปีการศึกษา</td>
            <td>${escHtml(yearDisplay)}</td>
            <td class="label">ห้องเรียน</td>
            <td>ม.${escHtml(c_class)}/${escHtml(r_no)}</td>
          </tr>
          <tr>
            <td class="label">ชื่อวิชา</td>
            <td>${escHtml(subName)}${subId ? ` (${escHtml(subId)})` : ''}</td>
            <td class="label">ชื่อผู้สอน</td>
            <td>${escHtml(getFullName() || '')}</td>
          </tr>
        </table>
        <table>
          ${colgroup}
          <thead>
            <tr>
              <th>เลขที่</th>
              <th>เลขประจำตัว<br/>นักเรียน</th>
              <th>ชื่อ - สกุล นักเรียน</th>
              ${scoreHeadCells}
            </tr>
          </thead>
          <tbody>${bodyRows}</tbody>
        </table>
        <!-- <div class="legend">
          <span class="box w"></span>จำหน่ายแล้ว
          <span class="box t"></span>ย้ายห้อง
        </div> -->
      </body></html>`

    const win = window.open('', '_blank', 'width=1200,height=900')
    win.document.write(html)
    win.document.close()
  }

  return (
    <React.Fragment>
      <Header onSkin={setSkin} />
      <div className="main main-app p-3 p-lg-4">
        <div className="d-sm-flex align-items-center justify-content-between mb-4">
          <div>
            <ol className="breadcrumb fs-sm mb-1">
              <li className="breadcrumb-item"><Link to="#">ข้อมูลการสอน</Link></li>
              <li className="breadcrumb-item"><Link to="#">แสดงรายชื่อนักเรียน</Link></li>
              <li className="breadcrumb-item active" aria-current="page">รายชื่อนักเรียนชั้น ม. {c_class + '/' + r_no}</li>
            </ol>
            <h4 className="main-title mb-0">รายชื่อนักเรียนชั้น ม. {c_class + '/' + r_no}</h4>
          </div>
        </div>

        <Row className="g-12 mb-4">
          <Col xl="12">
            <Card className="card-one">
              <Card.Header className="d-flex align-items-center justify-content-end gap-2 flex-wrap">
                <div className="btn-group btn-group-sm" role="group" aria-label="สลับมุมมอง">
                  <button type="button" className={`btn btn${view === 'table' ? '' : '-outline'}-primary`}
                    onClick={() => setView('table')} title="มุมมองตาราง">
                    <i className="ri-table-line" />
                  </button>
                  <button type="button" className={`btn btn${view === 'card' ? '' : '-outline'}-primary`}
                    onClick={() => setView('card')} title="มุมมองการ์ด">
                    <i className="ri-layout-grid-line" />
                  </button>
                </div>
                <Button
                  variant="primary"
                  size="sm"
                  onClick={handlePrintScoreSheet}
                  disabled={!data || data.length === 0}
                >
                  <i className="ri-printer-line me-1"></i>พิมพ์ใบบันทึกคะแนน
                </Button>
              </Card.Header>
              <Card.Body className="p-3">
                {view === 'card' ? (
                  <Row className="g-3">
                    {data && data.length > 0 ? data.map((s, index) => (
                      <Col key={s.st_id} xs={12} md={6} xl={4}>
                        <StudentCard data={s} index={index} />
                      </Col>
                    )) : (
                      <Col xs={12}><div className="text-center py-3">ไม่พบข้อมูล</div></Col>
                    )}
                  </Row>
                ) : (
                <Table responsive hover className="mb-0">
                  <thead>
                    <tr>
                      <th scope="col" className="text-center" style={{ width:"50px" }}>เลขที่</th>
                      <th scope="col" className="text-center" style={{ width: "100px" }}>เลขประจำตัว</th>
                      <th scope="col">ชื่อ-สกุล</th>
                      <th scope="col" className="text-center" style={{ width: "90px" }}>ช้ันศาสนา</th>
                      <th scope="col" className="text-center" style={{ width: "90px" }}>หอพัก</th>
                      <th scope="col" className="text-center" style={{ width: "120px" }}>สถานะ</th>
                      {/* <th scope="col" className="text-center" style={{ width: "150px" }}></th> */}
                    </tr>
                  </thead>
                  <tbody>
                  {data && data.length > 0 ? (
                  data.map((data, index) => {
                    const isWithdrawn = data.st_status === '0'
                    const isTransferred = !!data.transfer_room_id
                    return (
                      <tr key={data.st_id} className={isWithdrawn ? 'table-danger' : (isTransferred ? 'table-warning' : '')}>
                        <th scope="row" className="text-center">{index + 1}</th>
                        <td className="text-center">{data.st_idnumber}</td>
                        <td>
                          <div className="d-flex align-items-center gap-2">
                            <StudentAvatar photo={data.st_photo} name={data.st_name} />
                            <span>{data.st_name}</span>
                          </div>
                        </td>
                        <td className="text-center">{}</td>
                        <td className="text-center">{}</td>
                        <td className={isWithdrawn ? 'text-center text-danger' : (isTransferred ? 'text-center text-warning' : 'text-center text-success')}>
                          {isTransferred && !isWithdrawn
                            ? `ย้ายไป ม.${data.transfer_class_id}/${data.transfer_room_no}`
                            : data.status_text}
                        </td>
                        {/* <td className="text-center"><Link to={`/students/student-info/${data.st_id}`}><i className="ri-contacts-book-2-line"> แสดงข้อมูลนักเรียน</i></Link></td> */}
                      </tr>
                    )
                  })
                  ) : (
                    <tr>
                      <td colSpan={7} className="text-center">ไม่พบข้อมูล</td>
                    </tr>
                  )}
                  </tbody>
                </Table>
                )}
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <Footer />
      </div>
    </React.Fragment>
  )
}